module.exports = "/assets/data/667af5884a7bd434b73781391c9f8592-NE30.data.json";